import React from 'react';
import redInfo from 'assets/red-info.svg';
import './SubscriptionMessagingAlert.pcss';

type OuterProps = {
  remotePageId?: string;
};

export const SubscriptionMessagingAlert = ({ remotePageId }: OuterProps) => (
  <div className="subscription-messaging-alert__alert">
    <img
      className="subscription-messaging-alert__alert-img"
      src={redInfo}
      alt=""
    />
    <div>
      Your Facebook Page needs to be approved by Facebook to send Subscription
      Messages to your audience. Learn more about this&nbsp;
      <a
        className="subscription-messaging-alert__link"
        href="https://developers.facebook.com/docs/messenger-platform/policy/page-subscription-messaging"
        target="_blank"
        rel="noopener noreferrer"
      >
        Facebook policy
      </a>{' '}
      or&nbsp;
      <a
        className="subscription-messaging-alert__link"
        href="https://customers.ai/blog/2018/07/facebook-subscription-messaging"
        target="_blank"
        rel="noopener noreferrer"
      >
        read our guide
      </a>{' '}
      on how to apply.
    </div>
    <a
      className="subscription-messaging-alert__action subscription-messaging-alert__link"
      href={`https://www.facebook.com/${remotePageId}/settings/?tab=messenger_platform`}
      target="_blank"
      rel="noopener noreferrer"
    >
      APPLY NOW
    </a>
  </div>
);
